/* global SocketIOClient */
import React, { useEffect } from "react"
import { useLocation } from "react-router-dom"

import { useAuth } from "Shared/hooks/auth.hooks"
import { socketService } from "Shared/services/socketSync/socket.service"
import { isNodeEnvTest } from "Shared/utils/helper.utils"

export const SocketTracker = React.memo(({ onSocket }: { onSocket: (socket: SocketIOClient.Socket) => void }) => {
    const location = useLocation()?.pathname

    // DO NOT DELETE: useState is async and new values are not dispatched in real time like the event we are receiving
    let isConnectionLost = false

    const { userId } = useAuth()

    const handleSocketReconnection = async () => {
        isConnectionLost = false
        handleLostSocketConnection("ioState", true)
        await socketService.reconnect({ refreshToken: false })
    }

    /**
     * Handle socket connection lost from server crash to normal socket disconnection
     * @param _state do not delete it contains the socket state:: not used but mandatory for the event call
     * @param isReconnecting refiring the notification with loading state
     */
    const handleLostSocketConnection = async (_state: any, isReconnecting = false, shouldReload = false) => {
        if (!isConnectionLost) {
            isConnectionLost = true
            !isReconnecting && !shouldReload && (await handleSocketReconnection())
        }
    }

    /**
     * handle reconnection notification
     */
    const handleSuccessfulReconnection = () => {
        if (isConnectionLost) {
            isConnectionLost = false
        }
    }

    useEffect(() => {
        if (!isNodeEnvTest) {
            const globalSocket = socketService.connect({ loggedInUserId: userId!, onError: handleLostSocketConnection, onSuccess: handleSuccessfulReconnection })
            onSocket(globalSocket)
        }

        return () => {
            socketService.disconnect("LoggingOut")
        }
    }, [])

    useEffect(() => {
        socketService.setLocation(location)
    }, [location])

    return <></>
})
